import { createFileRoute } from '@tanstack/react-router';

import BuslineImports from '@/modules/buslines/pages/BuslineImports';

export const Route = createFileRoute(
  '/_authenticated/_system/_tenant/buslines/imports',
)({
  component: () => <BuslineImports />,
});
